import { all } from "redux-saga/effects";
import AppSaga from "./app-sagas";
import SettingCampaignSaga from "./setting-campaign/settings-campaign-sagas";
import storeInfoActions from "./store-infomation/store-infomation-sagas";
import reportActions from "./report-campaign/report-campaign-sagas";

export default function* rootSagas() {
  yield all([
    AppSaga(),
    SettingCampaignSaga(),
    storeInfoActions(),
    reportActions(),
  ]);
}
